module.exports = __webpack_public_path__ + "static/media/Mail.fa03506b.svg";